import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { graphql } from 'gatsby';
import { Layout, Code, Showcase, Header } from '../../../../components';
import './style.scss';
import data from './data.json';
import changelog from '../../../../data/changelog.json';
export const code = {
  flex: `<div class="u-flex-container"></div>
<div class="u-flex-align--left"></div>
<div class="u-flex-align--right"></div>
<div class="u-flex-align--center"></div>
<div class="u-flex-align--center-middle"></div>
<div class="u-flex-align--justify"></div>
<div class="u-flex-align--spaced"></div>
<div class="u-flex-align--top"></div>
<div class="u-flex-align--middle"></div>
<div class="u-flex-align--bottom"></div>
<div class="u-flex-align--stretch"></div>
<div class="u-flex-align-self--top"></div>
<div class="u-flex-align-self--middle"></div>
<div class="u-flex-align-self--bottom"></div>
<div class="u-flex-align-self--stretch"></div>
<div class="u-flex-child--auto"></div>
<div class="u-flex-child--grow"></div>
<div class="u-flex-child--shrink"></div>
<div class="u-flex-dir--row"></div>
<div class="u-flex-dir--row-reverse"></div>
<div class="u-flex-dir--column"></div>
<div class="u-flex-dir--column-reverse"></div>
`
};
export const _frontmatter = {};
const layoutProps = {
  code,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header site={data.site} slug={data.slug + '/design/'} state="design" title={data.title} mdxType="Header" />
    <Layout category={data.category} changelog={changelog[data.title].changelog} description={data.description} site={data.site} slug={data.slug + '/design/'} state="design" title={data.title} updated={data.updated} mdxType="Layout">
      <table>
  <thead>
    <th align="left">Color</th>
    <th align="left">Name</th>
    <th align="left">Value</th>
    <th align="left">Font</th>
    <th align="left">Background</th>
  </thead>
  <tbody>
    {data.colors.map(color => <tr>
        <td>
          <div className={'color-swatch ' + 'u-bg--' + `${color.class}`} />
        </td>
        <td>{color.name}</td>
        <td>{color.hex}</td>
        <td>
          <code className="table__code">.u-color--{color.class}</code>
        </td>
        <td>
          <code className="table__code">.u-bg--{color.class}</code>
        </td>
      </tr>)}
  </tbody>
      </table>
    </Layout>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      